export default {"src":"/_next/static/media/roadmap3.8bdd9260.svg","height":34,"width":34};